import { render, staticRenderFns } from "./create-or-update-detail.vue?vue&type=template&id=7f3fdcfc&scoped=true"
import script from "./create-or-update-detail.vue?vue&type=script&lang=js"
export * from "./create-or-update-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3fdcfc",
  null
  
)

export default component.exports